import { render } from "./ChallengeAndSolutionSection.vue?vue&type=template&id=61a543dc&scoped=true"
import script from "./ChallengeAndSolutionSection.vue?vue&type=script&lang=js"
export * from "./ChallengeAndSolutionSection.vue?vue&type=script&lang=js"

import "./ChallengeAndSolutionSection.vue?vue&type=style&index=0&id=61a543dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a543dc"]])

export default __exports__